module.exports = __webpack_public_path__ + "img/GVm-bg.4bd65156.png";